module.exports = require("react-number-format");